import { Modal, ModalBody } from "reactstrap";
import ForgotPasswordForm from "../form/ForgotPasswordForm";
import { modalZIndex } from "../../utils/UiUtils";

function ForgotPasswordModal({ isOpen, toggle }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={"lg"}
      backdrop={"static"}
      zIndex={modalZIndex()}
    >
      <ModalBody>
        <ForgotPasswordForm close={toggle} />
      </ModalBody>
    </Modal>
  );
}

export default ForgotPasswordModal;
